var maskStyleMapper = {
  mask: function mask(value, _) {
    return {
      style: {
        mask: value,
        WebkitMask: value
      }
    };
  },
  maskImage: function maskImage(value, _) {
    return {
      style: {
        maskImage: value,
        WebkitMaskImage: value
      }
    };
  }
};

export { maskStyleMapper };
//# sourceMappingURL=mask.js.map
